export default {
  title: 'Release History',
  tabCritical: 'Critical changes',
  tabReleases: 'Releases',
  from: 'From',
  to: 'To',
  version: 'Version',
  publishedDate: 'Published date',
  changeTitle: 'Title',
  whatChanged: 'What changed',
  customerImpact: 'Impact on the customer',
  actionRequired: 'Action required',
  effectiveDate: 'Effective date',
  summary: 'Summary',
  details: 'Details',
  viewDetails: 'View',
  closeDetails: 'Close',
  criticalEmpty: 'No critical changes that affect customer processing were issued from {{from}} to {{to}}.',
  releasesEmpty: 'No release notes are published.',
  loadError: 'The release history request failed.',
};
